function click_menu(item) {
  gtag('event', 'departmentView', {
    event: 'departmentView',
    deparmentName: item
  });
}

function click_submenu(item, subitem) {
  gtag('event', 'categoryView', {
    event: 'categoryView',
    deparmentName: item,
    categoryName: subitem
  });
}

function view_item(item) {
  let product = atob(item);
  product = JSON.parse(product);
  gtag('event', 'view_item', {
    currency: 'COP',
    items: [{
      item_id: product.variants[0].sku,
      item_name: product.title,
      item_brand: product.vendor,
      item_variant: product.variants[0].name,
      price: product.price,
      currency: 'COP',
    }],
    value: product.price
  });
}

function add_to_cart(product) {

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
  
  gtag('event', 'add_to_cart', {
      currency: 'COP',
      items: [{
        item_id: product.sku,
        item_name:  product.title,
        item_brand: product.vendor,
        item_variant: product.variant_title,
        price: formatter.format((product.price)?.toString().slice(0, -2)),
        currency: 'COP',
        quantity: product.quantity
      }],
      value: formatter.format((product.line_price)?.toString().slice(0, -2))
    });
}

function view_cart(products, total) {
  let items = [];
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
  products.forEach(item => items.push({
    item_id: item.variant_id,
    item_name: item.title,
    item_brand: item.vendor,
    item_variant: item.variant_title,
    price: formatter.format((item.price)?.toString().slice(0, -2)),
    currency: 'COP',
    sku: item.sku,
    product_id: item.product_id,
    product_type: item.product_type
  }));

  console.log(items);
  
  gtag('event', 'view_cart', {
    items: items,
    value: formatter.format((total)?.toString().slice(0, -2)),
    currency: 'COP',
    event: 'view_cart'
  });
}

$(document).ready(function(){
    let menu = '';
    $(".menu-item").click(function(event) {
        let element = $(this);
        click_menu(element[0].innerText);
        menu = element[0].innerText;
        console.log(menu);
    });
    $(".sub-item").click(function(event) {
        let element = $(this);
        click_submenu(menu, element[0].innerText);
        console.log(element);
        console.log(menu);
    });
});